import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceContentsCopyModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'checkbox',
        'serviceContentsId',
        'contentsName',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          serviceContentsId: 'コンテンツID',
          contentsName: 'コンテンツ名',
        },
        columnsClasses: {
          checkbox: 'wp-3',
          serviceContentsId: 'wp-5',
          contentsName: '',
        },
        sortable: [
          'serviceContentsId',
          'contentsName'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('コンテンツ'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: null,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      contentsSettingModel: state => state.serviceContentsCopyModal.contentsSettingModel,
      serviceId: state => state.serviceContentsCopyModal.serviceId,
      active: state => state.serviceContentsCopyModal.active,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // disabled
    disableConfirmButton () {
      if (this.inpDeliberyToKbn === null) return true
      if (this.checkList === null) return true
      return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceContentsCopyModal/loadModel',
      hide: 'serviceContentsCopyModal/hide',
      setUpdated: 'serviceContentsCopyModal/setUpdated',
      // reset: 'serviceContentsCopyModal/reset'
    }),

    init () {
      this.loading = true

      // データ更新フラグの初期化
      this.setUpdated(false)

      // storeをリセット
      // this.reset()

      //
      let contentsSettingParams = {
        serviceUuid: this.serviceId
      }
      console.log(contentsSettingParams)

      // データ読出し
      this.loadModel({
        contentsSettingParams: contentsSettingParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.contentsSettingModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.serviceContentsUuid
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'このコンテンツをコピーしますか？',
        acceptLabel: '登録'
      })
    },
    postData () {
      console.log('serviceUuid : ', this.serviceId)
      console.log('serviceContentsUuid : ', this.checkList)

      this.processing = true

      // 指定されたコンテンツ設定を取得
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsSettingDetailGet'],
        [{
          serviceUuid: this.serviceId,
          serviceContentsUuid: this.checkList,
        }])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // コピーしたコンテンツを登録
            let parameters = {
              serviceUuid: this.serviceId,
              request: {
                serviceContentsSettings: res[0].data.serviceContentsSettings
              }
            }
            console.log('register data', parameters)

            // 登録
            ApiManager.request(
              ['serviceContentsSetting'],
              ['v1ServiceContentsSettingPost'],
              [parameters])
              .then(res => {
                this.processing = false
                let status = Utility.parseResponse(res)

                if (status.result) {
                  // toast
                  this.showToast({
                    title: 'コンテンツのコピー',
                    body: 'コンテンツのコピーを登録しました。'
                  })

                  // データ更新フラグを有効
                  // 呼び出し元のページで一覧を更新するため
                  this.setUpdated(true)

                  this.closeModal()

                } else if (status.error) {
                  // エラーメッセージ表示
                  this.showError(res)
                } else {
                  // アプリケーションエラー表示
                  this.showError(null)
                }
                
              })
              // eslint-disable-next-line
              .catch(error => {
                this.processing = false
                this.showError(null)
              })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}